var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{attrs:{"name":_vm.name,"label":_vm.label,"hide-details":"","mandatory":""},model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}},_vm._l((_vm.types),function(type){return _c('v-radio',{key:type.value,attrs:{"label":type.label,"value":type.value,"color":"primary"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }